export default __webpack_public_path__ + "static/kristian-1ddbe2ecbb61ecee118e690718f5c305.jpg";